export default __webpack_public_path__ + "static/media/n.0bc739f8.svg";